import intersection from 'lodash.intersection';
import findByMatchingProperties from 'utils/find-matching-properties';


export function passesMultiCheckboxFilter(item, filter) {
    // IF the active filter does not have values then we pass the check without question
    if (!filter.values.length) { return true; }
    // Find the filter option on the item that matches the active filter
    const matchedItemFilterOptions = findByMatchingProperties(item.filterOptions, { code: filter.code });

    // if we did not find a match, then this item does not pass the filtering
    if (!matchedItemFilterOptions || !matchedItemFilterOptions.length) { return false; }

    // then check if all matched filter options have a match between their values array and the filter's values
    // if the array returned by intersection() has a length greater than zero, than it means there's a match to an or query
    // if its an and query we have to make sure that all the filters match so use every
    // filter.values is an array of the selected options

    let noMatch;
    if (filter.queryOperator === 'and') {
        noMatch = matchedItemFilterOptions.find(option =>
            intersection(option.values, filter.values).length < filter.values.length);
    } else {
        noMatch = matchedItemFilterOptions.find(option => !intersection(option.values, filter.values).length);
    }

    return noMatch === undefined;
}

export function countMultiCheckboxFilter(
    nonMatchFilters,
    value,
    filterCode,
    parent
) {
    const filterValue = `${filterCode}-${value}`;
    return parent ?
        nonMatchFilters.filter(f => f.startsWith(filterValue)).length :
        nonMatchFilters.filter(f => f === filterValue).length;
}
